import Notification from "../../components/Notification";

const NotificationPage = () => {
  return <Notification />;
};

export default NotificationPage;
